<template>
  <div class="hello">
    <div class="container-buttons">
      <div class="cc-buttons">
        <div class="buttons">
          <div class="getDate">
            <label for="fechaIni">Desde</label>
            <div class="datePicker">
              <input type="date" v-model="fechaIni" id="fechaIni" :max="fechaFin">
            </div>
          </div>
          <div class="getDate">
            <label for="fechaFin">Hasta</label>
            <div class="datePicker">
              <input type="date" v-model="fechaFin" id="fechaFin" :min="fechaIni">
            </div>
          </div>
          <div class="select">
            <label for="capas">Capas</label>
            <v-select :value="1" v-model="capas" :options="[1,2,3]" id="capas"/>
          </div>
          <div class="select">
            <label for="canales">Canales</label>
            <v-select :value="1" v-model="canal" :options="canales" id="canales"/>
          </div>
        </div>
        <div>
          <div class="select-multiple">
            <label for="links">Links</label>
            <v-select multiple v-model="options" :options="links" id="links" />
          </div>
        </div>
      </div>
      <button @click="getDataChart">Consultar</button>
    </div>
    <div v-show="cargando" class="loading">
      <img src="../assets/giphy.gif" alt="">
    </div>
    <div v-show="!cargando" class="hi" ref="chartdiv"></div> <!-- :style="{ height: capas * 500 + 'px' }" -->
  </div>
</template>

<script>
/* Imports */
import axios from 'axios';

import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

am4core.useTheme(am4themes_animated);

export default {
  name: 'Urls',
  components:{
    vSelect
  },
  data(){
    return {
      chart: null,
      cargando: true,
      dataChart: [], 
      url: 'https://us-central1-movistar-web-publica.cloudfunctions.net/ga_flow/consulta',
      urltest:'https://us-central1-movistar-web-publica.cloudfunctions.net/ga_flow_test/consulta',
      capas: 1,
      canal: null,
      canales: [
        'Direct',
        'Campañas',
        'Email',
        'Referral',
        'Social Media',
        'SEO',
        'Otros',
        '(Other)',
      ],
      options: ['/movistar-total'],
      links: [
        '/movistar-total',
        '/total-combo-movil-trio-beneficios',
        '/hogar/tv/planes',
        '/hogar/tv/beneficios',
        '/hogar/tv/experiencia-tv',
        '/hogar/duos-internet-tv-fijo',
        '/hogar/internet/internet-telefono-fijo-tv',
        '/hogar/internet/solo-internet',
        '/movil/preplan',
        '/movil/prepago/paquetes',
        '/movil/prepago/recargas',
        '/movil/postpago/portabilidad',
        '/movil/postpago/renueva-tu-equipo',
        '/movil/postpago/movistar-internacional',
        '/beneficios-prepago',
        '/prix',
      ],
      fechaIni: new Date(new Date().setDate(new Date().getDate()-1)).toISOString().slice(0,10),
      fechaFin: new Date(new Date().setDate(new Date().getDate()-1)).toISOString().slice(0,10)

    }
  },
  methods: {
    persist() {
      localStorage.dataChart = JSON.stringify(this.dataChart);
      console.log('now pretend I did more stuff...');
    },
    changeHeight(){
      if(this.$refs.chartdiv){
        if (!this.capas){
          this.$refs.chartdiv.style.height = '500px'
        }else{
          this.$refs.chartdiv.style.height = this.capas * 500 + 'px';
        }
      }
    },
    getDataChart(){
      this.cargando = true;
      this.changeHeight();

      axios.post(this.urltest, {
        capas: this.capas,
        canal: this.canal,
        links: this.options,
        fechaIni: this.replaceAll(this.fechaIni),
        fechaFin: this.replaceAll(this.fechaFin)
      }).then(({data}) => {
        this.dataChart = data;
        this.persist();
        this.cargando = false;
      }).catch(err => {
        this.dataChart = [];
        console.error(err);
      })

    },
    replaceAll(string, pattern = RegExp('-', 'g')){
      return string.replace(pattern,'')
    },
    printData(){
      console.log('capas: ' + this.capas);
      console.log('fechaIni: ' + this.replaceAll(this.fechaIni))
      console.log('fechaFin: ' + this.replaceAll(this.fechaFin))
      console.log('links');
      console.log(this.options);
      console.log('canales');
      console.log(this.canal)
    }
  },
  beforeMount(){
    if(localStorage.dataChart) {
      this.dataChart = JSON.parse(localStorage.dataChart);
      this.cargando = false;
    } else {
      this.getDataChart();
    }
  },
  mounted() {

    let chart = am4core.create(this.$refs.chartdiv, am4charts.SankeyDiagram);
    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

    chart.data = this.dataChart;

    chart.dataFields.fromName = 'desde';
    chart.dataFields.toName = 'hacia';
    chart.dataFields.value = 'valor';

    chart.sortBy = "value";
    let nodeTemplate = chart.nodes.template;
    nodeTemplate.draggable = false;

    chart.links.template.tooltipText = "Origen: {desde} \nDestino: {hacia} \nVisitas : {valor}";
    let hoverState = chart.links.template.states.create('hover');
    hoverState.properties.fillOpacity = 0.8;

    chart.paddingRight = 30;
    chart.paddingBottom = 30;
    
    chart.exporting.menu = new am4core.ExportMenu();

    this.chart = chart;
  },
  updated() {
    this.chart.data = this.dataChart;
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hi {
  width: 100%;
  height: 500px;
}

.loading img{
  width: 60%;
}

.buttons{
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.buttons > div{
  display: flex;
  flex-direction: column;
  align-items: baseline;
}

.cc-buttons{
  width: 80%;
}

.container-buttons {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 20px;
}

.datePicker{
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: flex;
  background: none;
  border: 1px solid rgba(60,60,60,.26);
  border-radius: 4px;
  white-space: normal;
  height: 30px;
}

.datePicker input{
  background-color: transparent;
  border: none;
  padding: 5px 10px;
}

.select-multiple {
  display: flex;
  flex-direction: column;
  align-items: baseline;
}

#links {
  width: 100%;
}

label {
  font-weight: bold;
  color: #2c3e50;
}

.container-buttons > button{
  background-color: #e6e9ea;
  border: solid darkgray 1px;
  border-radius: 10px;
  font-weight: bold;
  color: #2c3e50;
  width: 100px;
  height: 50px;
}

.container-buttons > button:active{
  box-shadow: 2px 2px 7px -4px;
}

#capas{
  min-width: 100px;
}

#canales{
  min-width: 200px;
}

@media (max-width: 480px) {
  
  .buttons {
    flex-direction: column;
    width: 100%;
  }

  .buttons > div , .select-multiple{
    margin-bottom: 10px;
    width: 100%;
  }

  .buttons > div > div, .buttons > div > div > input {
    width: 100%;
  }

  .container-buttons {
    flex-direction: column;
    align-items: center;
  }

  .cc-buttons {
    width: 100%;
  }

}

</style>
